import { HttpContextToken } from "@angular/common/http";

export const HIDE_ERROR_POPUP = "hide_error_popup";
export const DISABLE_ERROR_HANDLING = new HttpContextToken<boolean>(() => false);
